/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { NodePathVisitorFactory } from '../factories/NodePathVisitorFactory';
import { Node } from '../models/Node';
import { NodePath } from '../models/NodePath';
import { NodePathVisitor } from '../visitors/NodePathVisitor';
import { TraverserDirection } from '../visitors/TraverserDirection';
import { Document } from '../models/Document';
import { VisitorUtil } from './VisitorUtil';

/**
 * @author eric.wittmann@gmail.com
 * @class
 */
export class NodePathUtil {
    public static createNodePath(node : Node) : NodePath {
        let visitor : NodePathVisitor = NodePathVisitorFactory.createNodePathVisitor(node.ownerDocument());
        VisitorUtil.visitTree(node, visitor, TraverserDirection.up);
        return visitor.getPath();
    }
}
NodePathUtil["__class"] = "io.apicurio.datamodels.core.util.NodePathUtil";



